import { render, staticRenderFns } from "./AddCardiology.vue?vue&type=template&id=14be4ada&scoped=true"
import script from "./AddCardiology.vue?vue&type=script&lang=js"
export * from "./AddCardiology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14be4ada",
  null
  
)

export default component.exports